import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">Helvion Solutions</h3>
            <p className="footer-description">
              Leading IT company specializing in custom software development, cloud services, and managed IT solutions.
            </p>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-contact">
              <li><a href="mailto:info@helvionsolutions.com">info@helvionsolutions.com</a></li>
              <li><a href="tel:+447404666615">+44 7404666615</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {year} Helvion Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
